module.exports = __webpack_public_path__ + "blue-bg.svg?4e690f435599f73058920af807d5805d";